import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiSwitch from '@mui/material/Switch';

export function Switch({
  className,
  disabled,
  label,
  checked = false,
  onChange,
}) {
  return (
    <FormControlLabel
      disabled={disabled}
      className={className}
      control={
        <MuiSwitch color="secondary" checked={checked} onChange={onChange} />
      }
      label={label}
    />
  );
}

Switch.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};
